// Router `/login` ga GET navigatsiya: portal HTTPS da, `$(link-login-only)` esa oddiy HTTP —
// HTTPS→HTTP forma POST Chrome'da «forma xavfsiz emas» to'sig'ini chiqaradi. CHAP bo'lsa
// parol o'rnida md5 javobi ketadi, ochiq parol sahifadan chiqmaydi.
import { chapPassword, type ChapChallenge } from '../../shared/lib/chap'

export interface MikrotikLoginParams {
  loginUrl: string
  username: string
  password: string
  /** Kirishdan keyin qaytariladigan manzil — MikroTik `link-orig` */
  dst: string | null
  chap: ChapChallenge | null
}

export function mikrotikLoginUrl(params: MikrotikLoginParams): string {
  const password = params.chap ? chapPassword(params.chap, params.password) : params.password
  const fields: [string, string][] = [
    ['username', params.username],
    ['password', password],
    ...(params.dst ? [['dst', params.dst] as [string, string]] : []),
    ['popup', 'false'],
  ]
  const query = fields.map(([name, value]) => `${name}=${encodeURIComponent(value)}`).join('&')
  return `${params.loginUrl}${params.loginUrl.includes('?') ? '&' : '?'}${query}`
}

/** Faqat backend kirishni to'liq tasdiqlagach chaqiriladi (`docs/09-VENUE-PORTAL.md` §9.1). */
export function loginToMikrotik(params: MikrotikLoginParams): void {
  window.location.assign(mikrotikLoginUrl(params))
}
